var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 0C5.13667 0 0 5.13667 0 11.5C0 17.8633 5.13667 23 11.5 23C17.8633 23 23 17.8633 23 11.5C23 5.13667 17.8633 0 11.5 0ZM11.4489 17.6844C10.7589 17.6844 10.1967 17.1222 10.1967 16.4322C10.1967 15.7422 10.7589 15.18 11.4489 15.18C12.1389 15.18 12.7011 15.7422 12.7011 16.4322C12.7011 17.1222 12.1389 17.6844 11.4489 17.6844ZM11.5 14.3367C12.19 14.3367 12.7778 13.7744 12.7778 13.0844V6.54222C12.7778 5.85222 12.19 5.29 11.5 5.29C10.81 5.29 10.2222 5.85222 10.2222 6.54222V13.0844C10.2222 13.7744 10.81 14.3367 11.5 14.3367Z",
    fill: "#FC686F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleError);
export default __webpack_public_path__ + "static/media/circle-error.fe8593fbe906830abc371b92b02904e6.svg";
export { ForwardRef as ReactComponent };